module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/dan_bradley.jpg";